import { render, staticRenderFns } from "./dashboardJinduZhiye.vue?vue&type=template&id=5e07bbd0&scoped=true"
import script from "./dashboardJinduZhiye.vue?vue&type=script&lang=js"
export * from "./dashboardJinduZhiye.vue?vue&type=script&lang=js"
import style0 from "./dashboardJinduZhiye.vue?vue&type=style&index=0&id=5e07bbd0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e07bbd0",
  null
  
)

export default component.exports